import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  black: {
    backgroundColor: 'neutral.black',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    maxWidth: { md: 'calc( 100% - 515px)' },
  },
  wrapper: {
    padding: {
      sm: '32px 40px 40px 40px',
      xs: '30px 20px',
    },
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '16px',
    overflow: 'hidden',
    gap: {
      xs: '100px',
      sm: '24px',
    },
    width: '100%',
    border: '1px solid',
    borderColor: 'border.light',
    background:
      'linear-gradient(85.71deg, #0080FF 0%, #9F14E0 47.09%, #DB6904 100%)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  infoWrapper: {
    display: 'flex',
    gap: {
      xs: '30px',
      sm: '24px',
    },
    maxWidth: '600px',
    flexDirection: {
      xs: 'column',
      sm: 'row',
    },
    width: '100%',
  },
  button: {
    marginTop: '8px',
    padding: '0px 30px',
    paddingBlock: {
      xs: '12px',
    },
    fontWeight: '600',
    backgroundColor: 'background.paper',
    '&:hover': {
      backgroundColor: 'background.paper',
    },
  },
  animationTypography: {
    transform: 'translateY(0px)',
    opacity: 1,
    transition: 'transform 0.8s ease-out, opacity 0.8s ease-out',
  },
  animationTypographyAfter: {
    transform: 'translateY(100px)',
    opacity: '0',
  },
  arrowIcon: {
    color: 'neutral.black',
  },
  textField: {
    '& .MuiInput-root': {
      background: 'transparent',
    },
    '& .MuiInput-root:hover': {
      background: 'transparent',
    },
    '& .MuiInput-root:before': {
      borderBottomColor: 'border.light',
    },
    '& .MuiInput-root:after, .MuiInput-root:hover:after': {
      borderBottomColor: 'neutral.white',
    },
    '& .MuiInputBase-input::placeholder': {
      opacity: 1,
    },
    '& .MuiInputBase-input': {
      color: 'text.primaryDark',
    },
  },
  darkTextField: {
    '& .MuiInputBase-root': {
      minWidth: '100% !important',
      backgroundColor: 'transparent !important',
      '&.Mui-focused': {
        backgroundColor: 'custom.lightGrey !important',
      },
      '&:hover': {
        backgroundColor: 'custom.lightGrey !important',
      },
      '&::before': {
        borderBottom: '1px solid',
        borderColor: 'common.white',
      },
      '&:hover::before': {
        borderBottom: '1px solid',
        borderColor: '#ffffff1A !important',
      },
      '&.Mui-focused::before': {
        borderBottom: '1px solid',
        borderColor: 'border.light',
      },
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'transparent !important',
      },
      '&:hover fieldset': {
        borderColor: 'transparent !important',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'transparent !important',
      },
    },
    '& .MuiInputBase-input': {
      color: '#ffffff !important',
      '&::placeholder': {
        color: '#ffffff !important',
      },
    },
  },
  imageWrapper: {
    width: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#00000066',
  },
  image: {
    width: '28px',
    height: '24px',
  },
  bgImage: {
    width: '340px',
    height: '296px',
    position: 'absolute',
    right: '20px',
    bottom: 0,
    zIndex: 0,
    ' img': {
      top: 0,
      width: '100%',
      objectFit: 'initial',
      height: 'auto',
      zIndex: -1,
    },
    display: {
      xs: 'none',
      md: 'block',
    },
  },
  companyLogo: {
    ' img': {
      marginTop: '22px',
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      scale: 1.3,
    },
  },
  chipsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    alignItems: 'center',
  },
  chip: {
    height: '32px',
    borderRadius: '4px',
    padding: '4px 8px',
    color: 'neutral.white',
    backgroundColor: '#FFFFFF1A',
    alignItems: 'center',
    gap: '8px',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
